// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".title{color:#506784;letter-spacing:1px}.no-borders{border:0px !important}.age-range-box{min-width:250px}.region-preview-label{min-width:100px}", ""]);
// Exports
module.exports = exports;
